
import React from 'react';
import { ChevronRight } from 'lucide-react';

const ProcessSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16 reveal">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6">
            Your Journey to Data-Driven Operations
          </h2>
          <p className="text-lg text-muted-foreground">
            Our structured approach ensures that your organization successfully adopts data-driven 
            practices in a methodical and sustainable way.
          </p>
        </div>
        
        <div className="relative max-w-4xl mx-auto reveal">
          {/* Connect the steps with a vertical line */}
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-0.5 bg-primary/30 ml-1.5 md:ml-2.5 z-0 hidden md:block"></div>
          
          {/* Steps */}
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className="relative flex flex-col md:flex-row md:items-start gap-6">
                <div className="flex-none flex items-center justify-center w-8 h-8 md:w-12 md:h-12 rounded-full bg-primary text-white font-semibold z-10">
                  {index + 1}
                </div>
                <div className="flex-1 bg-secondary/10 rounded-xl p-6 md:p-8">
                  <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                  <p className="text-muted-foreground mb-4">{step.description}</p>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {step.activities.map((activity, idx) => (
                      <div key={idx} className="flex items-start">
                        <ChevronRight className="h-5 w-5 text-primary mr-2 mt-0.5 flex-shrink-0" />
                        <span className="text-sm">{activity}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const steps = [
  {
    title: "Discovery & Analysis",
    description: "We start by understanding your business objectives and identifying high-value data use cases.",
    activities: [
      "Business requirements gathering",
      "Current state assessment",
      "Use case prioritization",
      "ROI estimation and validation",
      "Stakeholder alignment",
      "Success metrics definition"
    ]
  },
  {
    title: "Solution Design",
    description: "Our experts design a tailored data platform architecture that meets your specific needs.",
    activities: [
      "Data architecture blueprint",
      "Source system integration planning",
      "Report and dashboard design",
      "Technology stack selection",
      "Security and governance framework",
      "Implementation roadmap"
    ]
  },
  {
    title: "Implementation",
    description: "We build and deploy your custom data platform with careful attention to quality and usability.",
    activities: [
      "Data warehouse development",
      "ETL/ELT pipeline implementation",
      "Custom dashboard creation",
      "User access management setup",
      "Testing and validation",
      "Documentation and knowledge base"
    ]
  },
  {
    title: "Adoption & Value Realization",
    description: "Our Customer Success Manager ensures your team adopts the solution and maximizes its value.",
    activities: [
      "User training and onboarding",
      "Data champion program",
      "Adoption monitoring",
      "Value tracking and reporting",
      "Continuous improvement",
      "Expanded use case development"
    ]
  }
];

export default ProcessSection;
